import { memo } from 'react';

import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';
import { ZippingTaskCompletedPanelItem } from '~/components/ZippingTasks/ZippingTaskCompletedPanelItem';
import { ZippingTaskFailedPanelItem } from '~/components/ZippingTasks/ZippingTaskFailedPanelItem';
import { ZippingTaskInProgressPanelItem } from '~/components/ZippingTasks/ZippingTaskInProgressPanelItem';
import { type GetTaskInStatus, type ZippingTask } from '~/store/tasks/types';

export type ZippingTasksPanelProps = {
  zippingTasks: ZippingTask[];
  onCancel: (localTaskId: ZippingTask['localTaskId']) => void;
  onClear: (localTaskId: ZippingTask['localTaskId']) => void;
  onHandleExpiredLink: (remoteTaskId: GetTaskInStatus<ZippingTask, 'completed'>['remoteTaskId']) => void;
};

export const ZippingTasksPanel = memo(
  ({ zippingTasks, onCancel, onClear, onHandleExpiredLink }: ZippingTasksPanelProps) => {
    return (
      <div data-testid="ZIPPING_TASK_PANEL">
        {zippingTasks.map((zipping) => {
          return (
            <PaneContainer key={zipping.localTaskId} className="mb-2 last:mb-0">
              {zipping.status === 'in-progress' ? (
                <ZippingTaskInProgressPanelItem onCancel={() => onCancel(zipping.localTaskId)} {...zipping} />
              ) : null}
              {zipping.status === 'completed' ? (
                <ZippingTaskCompletedPanelItem
                  onHandleExpiredLink={() => onHandleExpiredLink(zipping.remoteTaskId)}
                  onClear={() => onClear(zipping.localTaskId)}
                  {...zipping}
                />
              ) : null}
              {zipping.status === 'error' ? (
                <ZippingTaskFailedPanelItem onClear={() => onClear(zipping.localTaskId)} {...zipping} />
              ) : null}
            </PaneContainer>
          );
        })}
      </div>
    );
  },
);

ZippingTasksPanel.displayName = 'ZippingFilesPanel';
